module.exports = __webpack_public_path__ + "img/ChoirBG.ef37be30.jpg";